/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import 'aisztheme';

import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';
import {
  Row,
  Col,
  Panel,
  Table,
  Grid,
  Form,
  FormGroup,
  FormControl,
  ControlLabel,
} from 'react-bootstrap';
import { Set } from 'immutable';
import Toolbar from 'loracoms/Toolbar';
import RichButton from 'loracoms/RichButton';
import Nvl from 'loracoms/Nvl';
import Copy from 'loracoms/Copy';
import ControlTips from 'loracoms/ControlTips';
import InlineSelect from 'loracoms/InlineSelect';
import FormBlock from 'loracoms/FormBlock';
import ErrorSet from 'lorautils/errors/ErrorSet';
import IntlMsg from 'lorautils/intl/IntlMsg';
import { callAPI } from 'lorautils/api';
import {
  getAppTokenList,
} from 'loraapi/lora_application';
import {
  normalizeDevEUI,
  normalizeAppEUI,
  isValidDevEUI,
} from 'lorautils/IdUtils';
import {
  isInteger,
  isHexString,
} from 'lorautils/checkers/numbers';
import { compactFormat } from 'lorautils/DateTimeUtils';
import styles from './styles.scss';


const kEncodingOpts = [{
  label: 'HEX',
  value: 'hex',
}, {
  label: 'TEXT',
  value: 'text',
}];

const defaultProps = {
  data: [],
  wsFeedback: null,
  wsSocket: null,
};

const propTypes = {
  data: React.PropTypes.array,
  intl: React.PropTypes.object.isRequired,
  wsStatus: React.PropTypes.string.isRequired,
  wsType: React.PropTypes.string.isRequired,
  wsSocket: React.PropTypes.object,
  url: React.PropTypes.string.isRequired,
  appId: React.PropTypes.string.isRequired,
  pushState: React.PropTypes.func.isRequired,
  wsFeedback: React.PropTypes.any,
  resetFeedback: React.PropTypes.func.isRequired,
};

class DetailView extends React.Component {
  constructor(props) {
    super(props);
    this.intlMsg = new IntlMsg(props.intl, 'appdebug.detailview');
    this.state = {
      tokens: [],
      dataList: props.data || [],
      wsStatus: props.wsStatus,
      wsSocket: props.wsSocket,
      wsType: props.wsType,
      wsFeedback: props.wsFeedback,
      url: props.url,
      errors: (
        ErrorSet
          .createEmpty()
          .add('FE_EMPTY', 'deveui')
          .add('FE_EMPTY', 'fport')
          .add('FE_EMPTY', 'data')
      ),
      touched: new Set(),
      encoding: 'hex',
    };
  }

  componentDidMount() {
    this.getApiInfo();
  }

  componentWillReceiveProps(nextProps) {
    const { data, wsStatus, wsSocket, wsType, url, wsFeedback } = nextProps;
    if (data !== this.props.data) {
      this.setState({ dataList: data });
    }
    if (wsStatus !== this.props.wsStatus) {
      this.setState({ wsStatus });
    }
    if (wsSocket !== this.props.wsSocket) {
      this.setState({ wsSocket });
    }
    if (wsType !== this.props.wsType) {
      this.setState({ wsType });
    }
    if (url !== this.props.url) {
      this.setState({ url });
    }
    if (wsFeedback !== this.props.wsFeedback) {
      this.setState({ wsFeedback });
    }
  }


  getApiInfo() {
    getAppTokenList(this.props.appId).then((res) => {
      const tokens = res.body.list.map((t) => {
        const tk = t;
        tk.note = JSON.parse(t.aux || '{}').note;
        return tk;
      });
      this.setState({ tokens });
    });
  }

  getFeedbackError() {
    const { wsFeedback } = this.state;
    if (_.isNil(wsFeedback)) {
      return null;
    }
    return wsFeedback.error;
  }

  hasFeedbackError() {
    const { wsFeedback } = this.state;
    if (_.isNil(wsFeedback)) {
      return false;
    }
    return _.has(wsFeedback, 'error') && wsFeedback.error !== '';
  }

  isFeedbackSuccess() {
    const { wsFeedback } = this.state;
    if (_.isNil(wsFeedback)) {
      return false;
    }
    return !_.has(wsFeedback, 'error');
  }

  handleSendData() {
    const {
      wsSocket,
      wsType,
      url,
      deveui = '',
      fport = '',
      data = '',
      encoding = 'text',
      touched,
    } = this.state;
    let { errors } = this.state;

    this.props.resetFeedback();

    this.setState({
      touched: touched.add('deveui').add('fport').add('data'),
    });

    errors = errors.remove('submit');
    this.setState({ errors });

    if (!errors.isEmpty()) {
      return;
    }

    const sendData = {
      deveui: deveui.replace(/[-:]/g, ''),
      fport: parseInt(fport, 10),
      data,
      encoding,
    };

    if (wsType === 'ws') {
      if (wsSocket) {
        wsSocket.send(`${JSON.stringify(sendData)}\n`);
      }
    } else {
      this.setState({ sendStatus: 'loading' });
      callAPI({
        endpoint: url,
        body: sendData,
        method: 'POST',
      }).then(() => {
        this.setState({ sendStatus: 'success' });
      }).catch((error) => {
        this.setState({
          errors: errors.add(error.code, 'submit'),
        });
      });
    }
  }

  handleChange(v, id) {
    this.setState({ [id]: v });

    const { errors } = this.state;
    if (id === 'deveui') {
      if (v === '') {
        this.setState({ errors: errors.add('FE_EMPTY', 'deveui') });
      } else if (!isValidDevEUI(v)) {
        this.setState({ errors: errors.add('FE_INVALIDFMT', 'deveui') });
      } else {
        this.setState({ errors: errors.remove('deveui') });
      }
    } else if (id === 'fport') {
      if (v === '') {
        this.setState({ errors: errors.add('FE_EMPTY', 'fport') });
      } else if (!isInteger(v, { min: 1, max: 255 })) {
        this.setState({ errors: errors.add('FE_INVALIDPORT', 'fport') });
      } else {
        this.setState({ errors: errors.remove('fport') });
      }
    } else if (id === 'data') {
      const { encoding = 'hex' } = this.state;
      if (v === '') {
        this.setState({ errors: errors.add('FE_EMPTY', 'data') });
      } else if (encoding === 'hex' && !isHexString(v, { pair: true })) {
        this.setState({ errors: errors.add('FE_INVALIDHEX', 'data') });
      } else {
        this.setState({ errors: errors.remove('data') });
      }
    }
  }

  renderSendData() {
    const {
      errors,
      touched,
      sendStatus,
      deveui = '',
      fport = '',
      encoding = 'hex',
      data = '',
    } = this.state;

    return (
      <Form horizontal>
        <FormGroup>
          <Col md={2}>
            <ControlLabel bsClass="aisz-control-label">
              DevEUI
            </ControlLabel>
          </Col>
          <Col md={8}>
            <FormControl
              bsClass="aisz-form-control-f"
              placeholder="01-23-45-67-89-AB-CD-EF"
              value={deveui}
              onChange={e => this.handleChange(e.target.value, 'deveui')}
              onBlur={() => { this.setState({ touched: touched.add('deveui') }); }}
            />
            <ControlTips
              message={this.intlMsg.errorMsg(errors.get('deveui'))}
              show={errors.has('deveui') && touched.has('deveui')}
              azStyle="danger"
            />
          </Col>
        </FormGroup>
        <FormGroup>
          <Col md={2}>
            <ControlLabel bsClass="aisz-control-label">
              {this.intlMsg.msg('label.fport')}
            </ControlLabel>
          </Col>
          <Col md={8}>
            <FormControl
              bsClass="aisz-form-control-f"
              placeholder={this.intlMsg.msg('placeholder.fport')}
              value={fport}
              onChange={e => this.handleChange(e.target.value, 'fport')}
              onBlur={() => { this.setState({ touched: touched.add('fport') }); }}
            />
            <ControlTips
              message={this.intlMsg.errorMsg(errors.get('fport'))}
              show={errors.has('fport') && touched.has('fport')}
              azStyle="danger"
            />
          </Col>
        </FormGroup>
        <FormGroup>
          <Col md={2}>
            <ControlLabel bsClass="aisz-control-label">
              {this.intlMsg.msg('label.encoding')}
            </ControlLabel>
          </Col>
          <Col md={8}>
            <InlineSelect
              values={[encoding]}
              options={kEncodingOpts}
              onChange={dts => this.handleChange(dts[0], 'encoding')}
            />
          </Col>
        </FormGroup>
        <FormGroup>
          <Col md={2}>
            <ControlLabel bsClass="aisz-control-label">
              {this.intlMsg.msg('label.content')}
            </ControlLabel>
          </Col>
          <Col md={8}>
            <FormControl
              bsClass="aisz-form-control-f"
              placeholder={this.intlMsg.msg(`placeholder.data.${encoding}`)}
              componentClass="textarea"
              value={data}
              onChange={e => this.handleChange(e.target.value, 'data')}
              onBlur={() => { this.setState({ touched: touched.add('data') }); }}
            />
            <ControlTips
              message={this.intlMsg.errorMsg(errors.get('data'))}
              show={errors.has('data') && touched.has('data')}
              azStyle="danger"
            />
          </Col>
        </FormGroup>
        <FormGroup>
          <Col mdOffset={2} md={8}>
            <RichButton
              status={sendStatus}
              states={[{
                status: 'default',
                label: this.intlMsg.msg('button.send'),
                style: 'primary',
                onClick: () => this.handleSendData(),
              }, {
                status: 'pending',
                label: (
                  <span>
                    {this.intlMsg.msg('button.sending')}{' '}
                    <i className="fa fa-spinner fa-spin" />
                  </span>
                ),
                style: 'primary',
                onClick: () => {},
              }, {
                status: 'success',
                label: (
                  <span>
                    {this.intlMsg.msg('button.send.success')}{' '}
                    <i className="fa fa-check-circle" />
                  </span>
                ),
                style: 'success',
                timer: () => { this.setState({ sendStatus: '' }); },
              }, {
                status: 'failure',
                label: (
                  <span>
                    {this.intlMsg.msg('button.send.failure')}{' '}
                    <i className="fa fa-check-circle" />
                  </span>
                ),
                style: 'danger',
                timer: () => { this.setState({ sendStatus: '' }); },
              }]}
            />
          </Col>
        </FormGroup>
        <FormGroup>
          <Col mdOffset={2} md={8}>
            <FormBlock
              show={errors.has('submit')}
              message={this.intlMsg.errorMsg(errors.get('submit'))}
              azStyle="danger"
              closeButton
              onHide={() => { this.setState({ errors: errors.remove('submit') }); }}
            />
            <FormBlock
              show={this.hasFeedbackError()}
              message={this.getFeedbackError()}
              azStyle="danger"
              closeButton
              onHide={() => { this.props.resetFeedback(); }}
            />
            <FormBlock
              show={this.isFeedbackSuccess()}
              message={this.intlMsg.msg('feedback.success')}
              azStyle="success"
              closeButton
              onHide={() => { this.props.resetFeedback(); }}
            />
          </Col>
        </FormGroup>
      </Form>
    );
  }

  renderDetail() {
    const { url, appId } = this.props;
    const { tokens } = this.state;
    let debugType = '';
    let token = '';
    if (url !== '') {
      debugType = url.split(':')[0];
      token = url.split('&')[1].split('=')[1];
    }
    const apiInfo = {};
    tokens.forEach((item) => {
      if (item.token === token) {
        apiInfo.name = item.name;
        apiInfo.note = item.note;
      }
    });
    return (
      <div className={styles.props}>
        <div className={styles.title}>
          {this.intlMsg.msg('props.title')}
        </div>
        <ul>
          <li>
            <span className={styles.label}>
              {this.intlMsg.msg('props.name')}
            </span>
            <span className={styles.value}>
              {apiInfo.name}
            </span>
          </li>
          <li>
            <span className={styles.label}>
              {this.intlMsg.msg('props.apitype')}
            </span>
            <span className={styles.value}>{debugType}</span>
          </li>
          <li>
            <span className={styles.label}>
              {this.intlMsg.msg('props.remark')}
            </span>
            <span className={styles.value}><Nvl val={apiInfo.note} /></span>
          </li>
          <li>
            <span className={styles.label}>APPEUI</span>
            <span className={styles.value}>{normalizeAppEUI(appId)}</span>
          </li>
          <li>
            <span className={styles.label}>Token</span>
            <span className={styles.value}><Nvl val={token} /></span>
          </li>
        </ul>
      </div>
    );
  }

  renderToolbar() {
    const { appId, pushState } = this.props;
    const breadcrumb = [{
      content: this.intlMsg.msg('nav.api'),
      onClick: () => pushState(`/application/${appId}/api`),
    }, {
      content: this.intlMsg.msg('breadcrumb.detail'),
      active: true,
    }];
    return <Toolbar breadcrumb={breadcrumb} />;
  }

  renderWsStatus() {
    const { wsStatus } = this.state;
    if (wsStatus === 'connected') {
      return <i className="fa fa-refresh fa-spin text-success" />;
    } else if (wsStatus === 'closed') {
      return (
        <i className="fa fa-exclamation-circle text-warning">
          {' '}{this.intlMsg.msg('wsstatus.closed')}
        </i>
      );
    } else if (wsStatus === 'reconnecting') {
      return (
        <i className="fa fa-exclamation-circle text-warning">
          {' '}{this.intlMsg.msg('wsstatus.reconnecting')}
        </i>
      );
    }
    return null;
  }

  renderDataTable() {
    const { wsType } = this.props;
    const { dataList } = this.state;

    let header;
    if (wsType === 'ws') {
      header = <span>{this.intlMsg.msg('table.wstitle')}{' '}{this.renderWsStatus()}</span>;
    } else {
      header = <span>{this.intlMsg.msg('table.httptitle')}{' '}{this.renderWsStatus()}</span>;
    }

    const rows = dataList.map(item => (
      <tr key={`${item.deveui}-${item.fcnt}-${item.gateway}`}>
        <td>{compactFormat(item.$time)}</td>
        <td>
          {normalizeDevEUI(item.deveui)}{' '}
          <Copy id={`copy-${item.deveui}-${item.fcnt}-${item.gateway}`} text={item.deveui} />
        </td>
        <td>{item.frequency}</td>
        <td>{item.bandwidth}</td>
        <td>{item.coderate}</td>
        <td>{item.spreadfactor}</td>
        <td>{item.lorasnr}</td>
        <td>{item.fport}</td>
        <td>{item.rssi}</td>
        <td>{item.fcnt}</td>
        <td>{item.data}</td>
      </tr>
    ));

    return (
      <Panel bsStyle="aisz-white" header={header}>
        <Table className={`aisz-table-light ${styles.datatable}`} striped hover bordered responsive>
          <thead>
            <tr>
              <th>{this.intlMsg.msg('data.title')}</th>
              <th>DevEUI</th>
              <th> <i className="fa fa-wifi" />{' '} {this.intlMsg.msg('data.frequency')} </th>
              <th> <i className="fa fa-wifi" />{' '} {this.intlMsg.msg('data.bandwidth')} </th>
              <th> <i className="fa fa-wifi" />{' '} {this.intlMsg.msg('data.coderate')} </th>
              <th> <i className="fa fa-wifi" />{' '}SF </th>
              <th> <i className="fa fa-wifi" />{' '}SNR </th>
              <th> <i className="fa fa-envelope" />{' '}FPort </th>
              <th> <i className="fa fa-wifi" />{' '}RSSI </th>
              <th> <i className="fa fa-wifi" />{' '} {this.intlMsg.msg('data.fcnt')} </th>
              <th> <i className="fa fa-envelope" />{' '} {this.intlMsg.msg('data.data')} </th>
            </tr>
          </thead>
          <tbody>
            {rows}
          </tbody>
        </Table>
      </Panel>
    );
  }

  render() {
    return (
      <Grid fluid>
        <Row>
          <Col md={12}>
            {this.renderToolbar()}
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <Panel bsStyle="aisz-white">
              <Row>
                <Col md={5}>
                  {this.renderDetail()}
                </Col>
                <Col md={7}>
                  {this.renderSendData()}
                </Col>
              </Row>
            </Panel>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            {this.renderDataTable()}
          </Col>
        </Row>
      </Grid>
    );
  }
}

DetailView.defaultProps = defaultProps;
DetailView.propTypes = propTypes;

const mapDispatchToProps = {
  pushState: routerActions.push,
};

export default connect(null, mapDispatchToProps)(injectIntl(DetailView));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/APIView/coms/AppDebug/coms/DetailView/index.jsx